import React from 'react';
import { Box, Skeleton } from '@mui/material';

const LayoutSkeleton: React.FC = () => {
  return (
    <Box>
      <Box>
        <Skeleton variant="rectangular" animation="wave" width="100%" height={90} />
      </Box>
      <Box m={4}>
        <Skeleton variant="rounded" animation="wave" width="100%" height={500} />
      </Box>
      <Box mt={2}>
        <Skeleton variant="rectangular" animation="wave" width="100%" height={200} />
      </Box>
    </Box>
  );
};

export default LayoutSkeleton;
